<template>
    <div>
        <div class="target-component">
            <div class="d-flex justify-content-end">
                <div class="date-trigger-wrap" v-if="!goal.id">
                    <button class="calendar-trigger" @click="openPicker('resultPicker')">
                        <i class="el-icon-date"></i>
                    </button>
                    <el-date-picker
                        v-if="goal.goalType===0"
                        ref="resultPicker"
                        v-model="form.date"
                        type="date"
                        placeholder="Chọn ngày"
                        format="dd/MM/yyyy"
                        value-format="yyyy-MM-dd"
                        :clearable="false"
                        :editable="false"
                        append-to-body
                        class="invisible-picker"
                        :picker-options="disablePastDates"
                        @change="onPick"
                    />

                    <el-date-picker
                        v-else-if="goal.goalType===1"
                        ref="resultPicker"
                        v-model="form.date"
                        type="week"
                        placeholder="Chọn tuần"
                        value-format="yyyy-MM-dd"
                        :picker-options="{ ...disablePastDates, firstDayOfWeek: 1 }"
                        :clearable="false"
                        :editable="false"
                        append-to-body
                        class="invisible-picker"
                        @change="onPick"
                    />

                    <el-date-picker
                        v-else-if="goal.goalType===2"
                        ref="resultPicker"
                        v-model="form.date"
                        type="month"
                        placeholder="Chọn tháng"
                        format="MM/yyyy"
                        value-format="yyyy-MM"
                        :clearable="false"
                        :editable="false"
                        append-to-body
                        class="invisible-picker"
                        :picker-options="disablePastDates"
                        @change="onPick"
                    />
                </div>
            </div>

            <div class="mb-4">
                <label class="mr-1"><b>Số khách hàng có nhu cầu</b></label>
                <el-tooltip :content="'Giải thích: Là số lượng khách hàng có level 1A - nhu cầu: (khách hàng mới)'" placement="right">
                    <span class="text-muted"><i class="el-icon-question text-info mr-1"></i></span>
                </el-tooltip>
                <el-input class="mt-1" placeholder="Nhập số khách hàng có nhu cầu"
                          @input="form.targetCustomerNew = formatNumber(form.targetCustomerNew)"
                          v-model="form.targetCustomerNew"></el-input>
            </div>
            <div class="mb-4">
                <label class="mr-1"><b>Số khách hàng có lịch hẹn</b></label>
                <el-tooltip :content="'Giải thích: Là số lượng lịch hẹn (cuộc hẹn gặp mặt để làm thân, định hướng, tìm hiểu tài chính khách hàng)'" placement="right">
                    <span class="text-muted"><i class="el-icon-question text-info mr-1"></i></span>
                </el-tooltip>
                <el-input class="mt-1" placeholder="Nhập số khách hàng có lịch hẹn"
                          @input="form.targetCustomer2A = formatNumber(form.targetCustomer2A)"
                          v-model="form.targetCustomer2A"></el-input>
            </div>
            <div class="mb-4">
                <label><b>Số khách hàng lên tư vấn</b></label>
                <el-input class="mt-1" placeholder="Nhập mục tiêu số lịch tư vấn"
                          @input="form.targetScheduleNumber = formatNumber(form.targetScheduleNumber)"
                          v-model="form.targetScheduleNumber"></el-input>
            </div>
            <div class="mb-4">
                <label><b>Số hợp đồng</b></label>
                <el-input class="mt-1" placeholder="Nhập mục tiêu hợp đồng" v-model="form.targetContractNew"
                          @input="form.targetContractNew = formatNumber(form.targetContractNew)" >
                </el-input>
            </div>
            <div class="mb-2">
                <label><b>Doanh số</b></label>
                <el-input class="mt-1" placeholder="Nhập mục tiêu doanh số" v-model="form.targetAmount"
                          @input="form.targetAmount = formatNumber(form.targetAmount)" >
                </el-input>
            </div>
        </div>
        <div slot="footer" class="dialog-footer text-right rounded mt-4">
            <el-button :disabled="loading" style="background-color: #472f92" class="text-white" @click="handleSubmitExpectedReport" >
                <i :class="loading ? 'el-icon-loading' : ''"></i> {{this.goal.id ? 'Cập nhật' : 'Nhập'}} </el-button>
            <el-button @click="close()">Đóng</el-button>
        </div>
    </div>
</template>

<script>
import {CREATE_GOAL, UPDATE_GOAL} from "@/core/services/store/report.module";
import {mapGetters, mapState} from "vuex";

export default {
    name: "DialogHandleGoal",
    props: {
        goal: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            loading: false,
            form: {
                id: this.goal.id,
                date: this.goal.date,
                targetScheduleNumber: this.goal.targetScheduleNumber,
                targetCustomer2A:  this.goal.targetCustomer2A,
                targetCustomerNew: this.goal.targetCustomerNew,
                targetContractNew: this.goal.targetContractNew,
                targetAmount: this.goal.targetAmount,
                goalType: this.goal.goalType,
            },
            disablePastDates: {
                disabledDate(time) {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    return time.getTime() < today.getTime(); // chặn ngày nhỏ hơn hôm nay
                },
            },
        };
    },
    methods: {
        formatNumber(value) {
            if (typeof value === "string") {
                value = value.replace(/[^0-9]/g, "");
            }
            return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        handleSubmitExpectedReport() {
            this.loading = true;
            let payload = {
                target_schedule_number: this.form.targetScheduleNumber.toString().replace(/[.,]/g, ""),
                target_customer_new: this.form.targetCustomerNew.toString().replace(/[.,]/g, ""),
                target_amount: this.form.targetAmount.toString().replace(/[.,]/g, ""),
                target_contract_new: this.form.targetContractNew.toString().replace(/[.,]/g, ""),
                target_customer_2A: this.form.targetCustomer2A.toString().replace(/[.,]/g, ""),
                goal_type: this.form.goalType,
                time: this.form.date,
            };

            if (this.goal.id) {
                payload = {...payload, ...{ id: this.goal.id } };
                this.update(payload)
            } else {
                this.create(payload)
            }
        },

        create(payload) {
            this.loading = true;
            this.$store.dispatch(CREATE_GOAL, payload)
                .then((res) => {
                        this.$emit("updatedGoal");
                        this.$notify({
                            title: 'Success',
                            message: `${res.message ?? "Thành công"}`,
                            type: 'success'
                        });
                        this.loading = false;
                        this.close();
                }).catch((e) => {
                    this.$notify.error({
                        title: 'Error',
                        message: `${e.data.message ?? 'Đã có lỗi xảy ra, vui lòng thử lại sau!'}`,
                    });
                    this.close();
                    this.loading = false;
            });
        },

        update(payload) {
            this.$store.dispatch(UPDATE_GOAL, payload)
                .then((res) => {
                    this.$emit("updatedGoal");
                    this.$notify({
                        title: 'Success',
                        message: `${res.message ?? "Thành công"}`,
                        type: 'success'
                    });
                    this.loading = false;
                    this.close();
                }).catch((e) => {
                this.$notify.error({
                    title: 'Error',
                    message: `${e.data.message ?? 'Đã có lỗi xảy ra, vui lòng thử lại sau!'}`,
                });
                this.close();
                this.loading = false;
            });
        },

        openPicker(refName) {
            const dp = this.$refs[refName];
            this.$nextTick(() => {
                const input = dp?.$refs?.reference?.$refs?.input || dp?.$el?.querySelector('input');
                if (input) input.focus();
            });
        },

        onPick(val) {
            if (this.goal.goalType === 1 && val) {
                const [y, m, d] = String(val).split('-').map(Number);
                const base = new Date(y, m - 1, d);
                const dow = base.getDay() === 0 ? 7 : base.getDay(); // 1..7 (Mon..Sun)
                const start = new Date(base); start.setDate(base.getDate() - (dow - 1)); // Monday
                const end   = new Date(start); end.setDate(start.getDate() + 6);        // Sunday

                const monthStart = new Date(y, m - 1, 1);
                const monthEnd   = new Date(y, m, 0);

                const clampStart = start < monthStart ? monthStart : start;
                const clampEnd   = end   > monthEnd   ? monthEnd   : end;

                const fmt = (dt) =>
                    `${dt.getFullYear()}-${String(dt.getMonth()+1).padStart(2,'0')}-${String(dt.getDate()).padStart(2,'0')}`;
                this.form.date = [fmt(clampStart), fmt(clampEnd)];
            }

            this.$emit('changeTitleDialog', this.form.date, this.goal.goalType);
        },

        close() {
            this.$emit("close");
        },
    },
    computed: {
        ...mapState({
            errors: (state) => state.auth.errors,
        }),
        ...mapGetters(["currentUser"]),
    },
};
</script>

<style scoped>
.date-trigger-wrap { position:relative; display:inline-flex; align-items:center; }
.calendar-trigger { display:inline-flex; align-items:center; gap:8px; border:0; background:transparent; cursor:pointer; padding:4px 6px; border-radius:8px; transition:background .15s; }
.calendar-trigger .el-icon-date { font-size:18px; color:#22c55e; }
.calendar-trigger:hover { background:#f3f4f6; }
.invisible-picker { width:0!important; height:0!important; opacity:0!important; position:absolute!important; pointer-events:none!important; }
</style>
